export const EXCLUDED_DIRS: ReadonlySet<string> = new Set<string>([
    'node_modules',
    'build',
    'preview-build',
    '.DS_Store'
]);
